/** @format */

//category type for different qr codes
export const categoryType = {
  Organisation: 1,
  Team: 2,
  User: 3,
};

export const S3_BASEURL = `${process.env.REACT_APP_S3_BASE_URL}/`